/**
 * THE WIRE — what travels between the Final Few server and its screens.
 * It lives on its own Socket.IO namespace, /finalfew.
 */
export const FF_NAMESPACE = "/finalfew";
//# sourceMappingURL=protocol.js.map